/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreditAllocationClientResponse } from './CreditAllocationClientResponse';
import type { CreditCategoryResponse } from './CreditCategoryResponse';
export type CreditAllocationWithClientResponse = {
    validUntil: string | null;
    client: CreditAllocationClientResponse | null;
    id: number;
    therapistId: number;
    clientId: number;
    categoryId: number;
    totalCredits: number;
    usedCredits: number;
    source: CreditAllocationWithClientResponse.source;
    packagePurchaseId: number | null;
    isActive: boolean;
    note: string | null;
    createdAt: string;
    category: CreditCategoryResponse | null;
};
export namespace CreditAllocationWithClientResponse {
    export enum source {
        PACKAGE = 'package',
        AGREEMENT = 'agreement',
        PRO_BONO = 'pro_bono',
        OTHER = 'other',
    }
}

